// src/reducers/storesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiURL } from '../config/default';

export const fetchAllStores = createAsyncThunk(
  'stores/fetchAllStores',
  async (_, { rejectWithValue }) => {
    try {
      // Check for cached Brand data and timestamp
      const brandData = localStorage.getItem('Brand');
      const brandTimestamp = localStorage.getItem('BrandTimestamp');
      const now = Date.now();

      // If Brand data exists and is fresh (< 24 hours), use it directly
      if (brandData && brandTimestamp && now - parseInt(brandTimestamp, 10) < 24 * 60 * 60 * 1000) {
        return JSON.parse(brandData);
      }

      // Otherwise, fetch fresh data
      const res = await axios.get(`${apiURL}admin/all-stores`);
      const storeOptions = res.data.map((item) => ({
        id: item?._id,
        value: item?.fullName,
        label: item?.fullName,
      }));

      // Cache the new data and timestamp
      localStorage.setItem('Brand', JSON.stringify(storeOptions));
      localStorage.setItem('BrandTimestamp', now.toString());

      return storeOptions;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);


const storesSlice = createSlice({
    name: 'stores',
    initialState: {
        loading: false,
        error: null,
        stores: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllStores.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllStores.fulfilled, (state, action) => {
                state.loading = false;
                state.stores = action.payload;
            })
            .addCase(fetchAllStores.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default storesSlice.reducer;
